import BlogArticleRepository from "../BlogArticleRepository"

export default class ResourcesBlogList extends BlogArticleRepository {
    static schemaId = "resource_blogResource"

    constructor() {
        super(ResourcesBlogList.schemaId)
    }
}
